// @ts-nocheck
import React, { useState, useEffect } from "react";
import EyeIcon from "../components/EyeIcon";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { login as loginApi, register as registerApi, rotateBootstrapPassword as rotateBootstrapPasswordApi } from "../services/api";

function useResponsiveLoginStyles() {
  const isMobile = window.innerWidth <= 600;
  return {
    page: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      width: "100%",
      /* Beautiful blue background gradient */
      background: "linear-gradient(120deg, #2563eb 0%, #60a5fa 100%)",
      padding: isMobile ? 16 : 24,
      boxSizing: "border-box",
      position: "relative",
    },
    letterTile: {
      flex: 1,
      maxWidth: isMobile ? "98vw" : 420,
      marginRight: isMobile ? 0 : 32,
      marginBottom: isMobile ? 24 : 0,
      background: "linear-gradient(135deg, #f8fafc 0%, #e3e6ee 100%)",
      borderRadius: 22,
      boxShadow: "0 4px 24px #d0d4e0",
      border: "1.5px solid #e0e0e0",
      padding: isMobile ? 10 : 20,
      fontSize: isMobile ? 12 : 14,
      minHeight: isMobile ? 180 : 320,
      maxHeight: isMobile ? "none" : "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      overflow: "visible",
      transition: "box-shadow 0.2s, border 0.2s",
    },
    loginTile: {
      flex: isMobile ? "0 0 auto" : "0 1 340px",
      width: "100%",
      maxWidth: 340,
      background: "rgba(255,255,255,0.97)",
      borderRadius: 18,
      boxShadow: "0 2px 16px #e0e0e0",
      padding: isMobile ? 12 : 24,
      minHeight: isMobile ? 180 : 320,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      animation: "fadeInMinimal 0.7s cubic-bezier(.4,0,.2,1)",
      zIndex: 2,
      transition: "box-shadow 0.2s",
    },
    p: {
      margin: "16px 0",
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: "normal",
      textAlign: "center",
    },
    letterHeader: {
      fontWeight: 700,
      fontSize: isMobile ? 16 : 18,
      marginBottom: 10,
      color: "#1976d2",
      textAlign: "left",
    },
    letterContent: {
      fontSize: isMobile ? 11 : 13,
      color: "#222",
      whiteSpace: "pre-wrap",
      lineHeight: 1.45,
      textAlign: "left",
      background: "rgba(255,255,255,0.7)",
      borderRadius: 12,
      padding: isMobile ? 6 : 12,
      boxShadow: "0 1px 6px #e0e0e0",
      overflow: "visible",
      maxHeight: "none",
    },
    button: {
      width: "88%",
      display: "block",
      margin: "0 auto 10px auto",
      padding: isMobile ? "12px 0" : "15px 0",
      borderRadius: 8,
      border: "none",
      background: "#3256a2",
      color: "#fff",
      fontWeight: 600,
      fontSize: isMobile ? 16 : 18,
      letterSpacing: 0.5,
      cursor: "pointer",
      boxShadow: "0 1px 4px #e0e0e0",
      transition: "background 0.2s, color 0.2s, box-shadow 0.2s, transform 0.1s",
      outline: "none",
    },
    buttonAlt: {
      width: "88%",
      display: "block",
      margin: "0 auto 10px auto",
      padding: isMobile ? "12px 0" : "15px 0",
      borderRadius: 8,
      border: "none",
      background: "#ffa962",
      color: "#3256a2",
      fontWeight: 600,
      fontSize: isMobile ? 16 : 18,
      letterSpacing: 0.5,
      cursor: "pointer",
      boxShadow: "0 1px 4px #e0e0e0",
      transition: "background 0.2s, color 0.2s, box-shadow 0.2s, transform 0.1s",
      outline: "none",
    },
    input: {
      width: "84%",
      display: "block",
      margin: "0 auto 14px auto",
      padding: 12,
      borderRadius: 8,
      border: "1.5px solid #e0e0e0",
      fontSize: 16,
      background: "#f5f7fa",
      transition: "border-color 0.2s, box-shadow 0.2s",
      textAlign: "center",
      outline: "none",
    },
    inputFocus: {
      border: "1.5px solid #3256a2",
      boxShadow: "0 0 0 2px #ffa96233",
    },
    error: {
      color: "#dc2626",
      marginTop: 10,
      fontWeight: 500,
      fontSize: 14,
      textAlign: "center",
      background: "#fff3f3",
      borderRadius: 8,
      padding: "7px 0",
      boxShadow: "0 1px 4px #e0e0e0",
    },
    footer: {
      marginTop: 28,
      textAlign: "center",
      color: "#3256a2",
      fontSize: isMobile ? 12 : 14,
      fontWeight: 400,
      letterSpacing: 0.3,
    },
    toggleLink: {
      color: "#ffa962",
      cursor: "pointer",
      textDecoration: "underline",
      fontWeight: 500,
      fontSize: 14,
      margin: "0 4px",
      background: "none",
      border: "none",
      padding: 0,
    },
    fadeIn: {
      animation: "fadeInMinimal 0.7s cubic-bezier(.4,0,.2,1)",
    },
    success: {
      color: "#22bb55",
      textAlign: "center",
      fontWeight: 600,
      margin: "10px 0 0 0",
      fontSize: 15,
      letterSpacing: 0.2,
      transition: "color 0.3s",
    },
  };
}
export default function Login() {
  const [showPassword, setShowPassword] = useState<any>(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState<any>(false);
  const [showRotateCurrent, setShowRotateCurrent] = useState<any>(false);
  const [showRotateNew, setShowRotateNew] = useState<any>(false);
  const [showRotateConfirm, setShowRotateConfirm] = useState<any>(false);
    // Include both display names and backend-normalized names (parent→family, admin→school_admin)
    const ROLE_PRIORITY = ["developer", "superadmin", "admin", "school_admin", "teacher", "special_services_teacher", "parent", "family", "student"];

    function resolvePrimaryRole(roles = []) {
      if (!Array.isArray(roles) || roles.length === 0) return null;
      const byPriority = ROLE_PRIORITY.find((r) => roles.includes(r));
      return byPriority || roles[0];
    }

    // Helper to redirect by role — handles both display names and RBAC-normalized names
    function redirectByRole(role) {
      if (role === "developer") {
        navigate("/developer/home");
      } else if (role === "superadmin") {
        navigate("/superadmin/home");
      } else if (role === "admin" || role === "school_admin" || role === "district_admin") {
        navigate("/admin");
      } else if (role === "teacher" || role === "special_services_teacher") {
        navigate("/teacher/home");
      } else if (role === "student") {
        navigate("/student/home");
      } else if (role === "parent" || role === "family") {
        navigate("/parent/home");
      } else {
        navigate("/dashboard");
      }
    }

    // Registration handler
    const handleRegister = async (e) => {
      e.preventDefault();
      setError("");
      setSuccess("");
      setLoading(true);
      try {
        const user = { first_name: firstName, last_name: lastName, email, password };
        await registerApi(user);
        setSuccess("Registration successful! Redirecting...");
        setTimeout(async () => {
          try {
            const loginData = await loginApi(email, password);
            const roles = Array.isArray(loginData.roles) ? loginData.roles : [];
            const primaryRole = resolvePrimaryRole(roles);
            if (!loginData.user || !primaryRole) {
              setError("Registration succeeded but login failed. Please try logging in.");
              setLoading(false);
              return;
            }
            const enrichedUser = { ...loginData.user, roles, role: primaryRole };
            login({ user: enrichedUser, access_token: loginData.access_token });
            redirectByRole(primaryRole);
          } catch (err: any) {
            setError("Registration succeeded but login failed. Please try logging in.");
            setLoading(false);
          }
        }, 900);
      } catch (err: any) {
        setError(err.message);
        setLoading(false);
      }
    };

    // Button hover effects
    const handleButtonMouseOver = e => {
      e.currentTarget.style.background = '#ffa962';
      e.currentTarget.style.color = '#3256a2';
      e.currentTarget.style.transform = 'scale(1.03)';
    };
    const handleButtonMouseOut = e => {
      e.currentTarget.style.background = '#3256a2';
      e.currentTarget.style.color = '#fff';
      e.currentTarget.style.transform = 'scale(1)';
    };
  const styles = useResponsiveLoginStyles();
  const [letter, setLetter] = useState<any>("");
  const [showLetter, setShowLetter] = useState<any>(false);
  const [isRegister, setIsRegister] = useState<any>(false);
  const [email, setEmail] = useState<any>("");
  const [password, setPassword] = useState<any>("");
  const [firstName, setFirstName] = useState<any>("");
  const [lastName, setLastName] = useState<any>("");
  const [error, setError] = useState<any>("");
  const [loading, setLoading] = useState<any>(false);
  const [success, setSuccess] = useState<any>("");
  const [otpCode, setOtpCode] = useState<any>("");
  const [requires2FA, setRequires2FA] = useState<any>(false);
  const [showBootstrapRotate, setShowBootstrapRotate] = useState<any>(false);
  const [rotateCurrentPassword, setRotateCurrentPassword] = useState<any>("");
  const [rotateNewPassword, setRotateNewPassword] = useState<any>("");
  const [rotateConfirmPassword, setRotateConfirmPassword] = useState<any>("");
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    fetch("/founder_letter.txt")
      .then((res) => res.text())
      .then(setLetter);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const data = await loginApi(email, password, otpCode || null);

      if (data?.requires_2fa) {
        setRequires2FA(true);
        setLoading(false);
        setSuccess("Enter your 6-digit authenticator code to finish signing in.");
        return;
      }

      setRequires2FA(false);
      setShowBootstrapRotate(false);
      const userRoles = Array.isArray(data.roles) ? data.roles : [];
      const userRole = resolvePrimaryRole(userRoles);
      const user = {
        ...data.user,
        role: userRole,
        roles: userRoles,
        onboarding_required: Boolean(data.onboarding_required ?? data.user?.onboarding_required),
        billing_status: data.billing_status ?? data.user?.billing_status,
        payment_required: Boolean(data.payment_required ?? data.user?.payment_required),
      };
      if (!user.role) {
        setError("Login failed: user role not found. Please check your credentials or contact admin.");
        setLoading(false);
        return;
      }
      login({ user, access_token: data.access_token });
      setSuccess("Welcome back!");
      if (data.must_change_password) {
        setTimeout(() => navigate("/change-password"), 700);
      } else if (user.onboarding_required) {
        setTimeout(() => navigate("/admin/onboarding"), 700);
      } else {
        setTimeout(() => redirectByRole(user.role), 700);
      }
    } catch (err: any) {
      setError(err.message);
      setShowBootstrapRotate(err.message.includes("Password rotation required"));
      if (err.message.includes("Password rotation required")) {
        setRotateCurrentPassword(password || "");
      }
      setLoading(false);
    }
  };

  const handleBootstrapPasswordRotation = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Enter the bootstrap email first.");
      return;
    }
    if (!rotateCurrentPassword || !rotateNewPassword || !rotateConfirmPassword) {
      setError("Fill all password rotation fields.");
      return;
    }
    if (rotateNewPassword !== rotateConfirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    setLoading(true);
    try {
      await rotateBootstrapPasswordApi(email, rotateCurrentPassword, rotateNewPassword);
      const data = await loginApi(email, rotateNewPassword);
      const userRoles = Array.isArray(data.roles) ? data.roles : [];
      const userRole = resolvePrimaryRole(userRoles);
      const user = { ...data.user, role: userRole, roles: userRoles };

      login({ user, access_token: data.access_token });
      setSuccess("Password rotated. Logged in successfully.");
      setShowBootstrapRotate(false);
      setPassword(rotateNewPassword);
      setTimeout(() => redirectByRole(user.role), 700);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const logoUrl = "/academic-eye-logo.png";
  return (
    <>
      <style>{`
        @keyframes fadeInMinimal {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        input:focus {
          border: 1.5px solid #3256a2 !important;
          box-shadow: 0 0 0 2px #ffa96233 !important;
        }
      `}</style>
      <div style={styles.page}>
        {showLetter && (
          <aside style={styles.letterTile} aria-label="Letter from the founder">
            <h2 style={styles.letterHeader}>A Letter from the Founder</h2>
            <div style={styles.letterContent}>{letter}</div>
          </aside>
        )}
        <main style={styles.loginTile}>
          <img
            src={logoUrl}
            alt="Academic Eye Logo"
            style={{ display: "block", flexShrink: 0, margin: "0 auto 16px", width: 120, height: 120, objectFit: "cover", borderRadius: 18, boxShadow: "0 2px 8px #3256a2", border: "2px solid #ffa962", cursor: "pointer" }}
            onClick={() => setShowLetter((prev) => !prev)}
            title={showLetter ? "Hide founder's letter" : "Show founder's letter"}
          />
          <h1 style={{ ...styles.p, margin: "0 0 8px" }}>
            {isRegister ? "Create your account" : "Sign in to your account"}
          </h1>
          <div style={{ textAlign: "center", marginBottom: 18 }}>
            {isRegister ? (
              <>
                <span style={{ color: "#5f949b", fontSize: 14 }}>Already have an account?</span>
                <button style={styles.toggleLink} onClick={() => { setIsRegister(false); setError(""); setSuccess(""); setRequires2FA(false); setOtpCode(""); }}>Login</button>
              </>
            ) : (
              <>
                <span style={{ color: "#5f949b", fontSize: 14 }}>New here?</span>
                <button style={styles.toggleLink} onClick={() => { setIsRegister(true); setError(""); setSuccess(""); setRequires2FA(false); setOtpCode(""); }}>Register</button>
              </>
            )}
          </div>
          {isRegister ? (
            <form onSubmit={handleRegister} style={styles.fadeIn} autoComplete="off">
              <label htmlFor="register-first-name" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>First Name</label>
              <input
                id="register-first-name"
                type="text"
                placeholder="First Name"
                autoComplete="given-name"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                required
                style={styles.input}
              />
              <label htmlFor="register-last-name" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Last Name</label>
              <input
                id="register-last-name"
                type="text"
                placeholder="Last Name"
                autoComplete="family-name"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                required
                style={styles.input}
              />
              <label htmlFor="register-email" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Email</label>
              <input
                id="register-email"
                type="email"
                placeholder="Email"
                autoComplete="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={styles.input}
              />
              <div style={{ position: 'relative', width: '84%', margin: '0 auto 14px auto', display: 'flex', alignItems: 'center' }}>
                <label htmlFor="register-password" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Password</label>
                <input
                  id="register-password"
                  type={showRegisterPassword ? "text" : "password"}
                  placeholder="Password"
                  autoComplete="new-password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  style={{ ...styles.input, width: '100%', margin: 0, paddingRight: 38 }}
                />
                <button
                  type="button"
                  onClick={() => setShowRegisterPassword(v => !v)}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    lineHeight: 1,
                  }}
                  aria-label={showRegisterPassword ? 'Hide password' : 'Show password'}
                >
                  <EyeIcon open={showRegisterPassword} style={{ opacity: 0.85 }} />
                </button>
              </div>
              <button
                type="submit"
                style={styles.button}
                onMouseOver={handleButtonMouseOver}
                onMouseOut={handleButtonMouseOut}
                disabled={loading}
              >
                {loading ? "Registering..." : "Register"}
              </button>
              {success && <div style={styles.success}>{success}</div>}
              {error && <div style={styles.error}>{error}</div>}
            </form>
          ) : (
            <form onSubmit={handleLogin} style={styles.fadeIn} autoComplete="on">
              <div style={{ width: '84%', margin: '0 auto 14px auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
                <label htmlFor="login-email" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Email</label>
                <input
                  id="login-email"
                  type="email"
                  placeholder="Email"
                  autoComplete="username"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={{ ...styles.input, width: '100%', margin: 0, borderRadius: 8, boxSizing: 'border-box', height: 48, fontSize: 16, paddingRight: 16 }}
                />
                <div style={{ position: 'relative', width: '100%' }}>
                  <label htmlFor="login-password" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Password</label>
                  <input
                    id="login-password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    autoComplete="current-password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    style={{ ...styles.input, width: '100%', margin: 0, borderRadius: 8, boxSizing: 'border-box', height: 48, fontSize: 16, paddingRight: 40 }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(v => !v)}
                    style={{
                      position: 'absolute',
                      right: 10,
                      top: 0,
                      height: 48,
                      display: 'flex',
                      alignItems: 'center',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 0,
                      lineHeight: 1,
                    }}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    <EyeIcon open={showPassword} style={{ opacity: 0.85, width: 24, height: 24 }} />
                  </button>
                </div>
                {requires2FA && (
                  <>
                    <label htmlFor="login-otp" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Authenticator code</label>
                    <input
                      id="login-otp"
                      type="text"
                      placeholder="Authenticator code (6 digits)"
                      autoComplete="one-time-code"
                      inputMode="numeric"
                      value={otpCode}
                      onChange={e => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      required={requires2FA}
                      style={{ ...styles.input, width: '100%', margin: 0, borderRadius: 8, boxSizing: 'border-box', height: 48, fontSize: 16, paddingRight: 16, letterSpacing: '0.24em' }}
                    />
                  </>
                )}
              </div>
              <button
                type="submit"
                style={styles.button}
                onMouseOver={handleButtonMouseOver}
                onMouseOut={handleButtonMouseOut}
                disabled={loading}
              >
                {loading ? "Logging in..." : (requires2FA ? "Verify & Login" : "Login")}
              </button>
              <button type="button" onClick={() => navigate('/forgot-password')} style={{ display: 'block', margin: '2px auto 0', padding: 0, border: 'none', background: 'none', color: '#3256a2', fontSize: 13, fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
                Forgot password?
              </button>
              {showBootstrapRotate && (
                <div style={{ width: "88%", margin: "8px auto 12px", border: "1px solid #fde68a", background: "#fffbeb", borderRadius: 8, padding: 10 }}>
                  <div style={{ fontSize: 13, color: "#92400e", marginBottom: 8, fontWeight: 600 }}>
                    First login security step: rotate bootstrap password.
                  </div>
                  <form onSubmit={handleBootstrapPasswordRotation} style={{ display: "grid", gap: 8 }}>
                    <div style={{ position: 'relative', marginBottom: 8 }}>
                      <input
                        type={showRotateCurrent ? 'text' : 'password'}
                        placeholder="Current bootstrap password"
                        value={rotateCurrentPassword}
                        onChange={e => setRotateCurrentPassword(e.target.value)}
                        required
                        style={{ ...styles.input, width: '100%', margin: 0, paddingRight: 38 }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowRotateCurrent(v => !v)}
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          lineHeight: 1,
                        }}
                        tabIndex={-1}
                        aria-label={showRotateCurrent ? 'Hide password' : 'Show password'}
                      >
                        <EyeIcon open={showRotateCurrent} style={{ opacity: 0.85 }} />
                      </button>
                    </div>
                    <div style={{ position: 'relative', marginBottom: 8 }}>
                      <input
                        type={showRotateNew ? 'text' : 'password'}
                        placeholder="New password (min 12 chars)"
                        value={rotateNewPassword}
                        onChange={e => setRotateNewPassword(e.target.value)}
                        required
                        style={{ ...styles.input, width: '100%', margin: 0, paddingRight: 38 }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowRotateNew(v => !v)}
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          lineHeight: 1,
                        }}
                        tabIndex={-1}
                        aria-label={showRotateNew ? 'Hide password' : 'Show password'}
                      >
                        <EyeIcon open={showRotateNew} style={{ opacity: 0.85 }} />
                      </button>
                    </div>
                    <div style={{ position: 'relative', marginBottom: 8 }}>
                      <input
                        type={showRotateConfirm ? 'text' : 'password'}
                        placeholder="Confirm new password"
                        value={rotateConfirmPassword}
                        onChange={e => setRotateConfirmPassword(e.target.value)}
                        required
                        style={{ ...styles.input, width: '100%', margin: 0, paddingRight: 38 }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowRotateConfirm(v => !v)}
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          lineHeight: 1,
                        }}
                        tabIndex={-1}
                        aria-label={showRotateConfirm ? 'Hide password' : 'Show password'}
                      >
                        <EyeIcon open={showRotateConfirm} style={{ opacity: 0.85 }} />
                      </button>
                    </div>
                    <button
                      type="submit"
                      style={{ ...styles.buttonAlt, width: "100%", margin: 0, padding: "10px 0" }}
                      disabled={loading}
                    >
                      {loading ? "Rotating..." : "Rotate Password & Continue"}
                    </button>
                  </form>
                </div>
              )}
              {success && <div style={styles.success}>{success}</div>}
              {error && <div style={styles.error}>{error}</div>}
            </form>
          )}
          <div style={styles.footer}>
                  <div><span style={{ color: "#ffa962" }}>Academic Eye</span></div>
                  <div>See Learning Clearly.</div>
                  <div style={{ marginTop: 8 }}>
                    <a
                      href="/privacy"
                      style={{ color: "#3256a2", fontSize: 12, fontWeight: 700, textDecoration: "underline" }}
                    >
                      Privacy Policy
                    </a>
                  </div>
          </div>
        </main>
      </div>
    </>
  );
}